import { format } from "date-fns";
import { useContext } from "react";
import { es } from "date-fns/locale";
import { IReservation } from "./useSteps";
import useRoutes from "@/hooks/useRoutes";
import { formatPhone } from "@/utils/phones";
import { WebsiteContext } from "@/pages/website/WebsiteProvider";

const useSendThroughWhatsapp = () => {
  const [navigate] = useRoutes();
  const { organization } = useContext(WebsiteContext);

  const sendOrder = async (values: IReservation) => {
    if (!values || !organization?.whatsapp) return;

    const BULLET = "%2A";
    const NEW_LINE = "%0A";

    const hour = format(new Date(String(values.time)), "h:mm a", { locale: es });
    const date = format(new Date(String(values.date)), "eeee dd 'de' MMMM 'de' yyyy", { locale: es });

    const message = `Hola me gustaría reservar una mesa: ${NEW_LINE}${NEW_LINE} A nombre de: ${values.name} ${
      values.lastname
    } ${NEW_LINE} Fecha: ${date} ${NEW_LINE} Horario: ${hour} ${NEW_LINE} Teléfono: ${formatPhone(
      values.phone,
      505
    )} ${NEW_LINE}${NEW_LINE} ${BULLET} Por favor confírmenme la disponibilidad lo antes posible!`;

    window.open(`https://wa.me/505${organization?.whatsapp}?text=${message}`);

    navigate("organizations.reservations.main");
  };

  return sendOrder;
};

export default useSendThroughWhatsapp;
